export default "https://cdn-web.disco.co/quiz_generator-9d8507d9b89e277e023132dc6a8724ae.png";